import { ArticleLevel } from "@/types/models/ArticleLevel.interface";
import { ContentLevel } from "@/types/models/Content.interface";
import findClosestGradeBand from "@/utils/findClosestGradeBand";

function getBestLanguageMatch<T extends ContentLevel>(
  filteredByLanguageList: T[],
  currentLevel: ArticleLevel,
): T | undefined {
  if (filteredByLanguageList.length) {
    const possibleGradeBands = filteredByLanguageList.map(
      (level) => level.grade_band,
    );
    const closestLanguageMatch = findClosestGradeBand(
      currentLevel.grade_band,
      possibleGradeBands,
    );
    return filteredByLanguageList.find(
      (level: T) => level.grade_band === closestLanguageMatch,
    );
  }
  return undefined;
}

export default getBestLanguageMatch;
